import { Select } from '../src/libs/index.ts';

document.querySelectorAll('.custom-select:not(.applied)').forEach((parent) => {
  const select = parent.querySelector('select');
  const { labelNone, labelOne, labelSome } = select.dataset;

  parent.classList.add('applied');

  Select({
    select,
    renderSelected: (count) => {
      if (count > 1) {
        return labelSome.replace('{{count}}', count);
      }
      if (count === 1) {
        return labelOne;
      }
      return labelNone;
    },
  });
});
